import { VFC } from 'react'
import { ButtonLink } from 'src/elements/Link'
import {
  _profilemenubg,
  accentColor,
  errorRed,
  orange,
  truewhite,
} from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import { NEEDS } from 'src/utils/routes'
import styled from 'styled-components'
import { ModalDetail } from './ProfileForm'

export const Messages: VFC<{
  submitSucceeded: boolean
  errorMessages: string[]
  succeededMessage?: string
}> = ({ submitSucceeded, errorMessages, succeededMessage }) => (
  <>
    {submitSucceeded && (
      <SucceededMessage>
        <div>
          <p>
            {succeededMessage ? succeededMessage : '企業情報が更新されました！'}
          </p>
          <ButtonLink href={NEEDS}>企業を探しに行く</ButtonLink>
        </div>
      </SucceededMessage>
    )}
    {errorMessages.length > 0 && (
      <ErrorMessages>
        <p>入力内容をもう一度確認してください。</p>
        <div>
          {errorMessages.map((message) => (
            <p key={message}>{message}</p>
          ))}
        </div>
      </ErrorMessages>
    )}
  </>
)

export const LowerLeftMessageModal: VFC<{
  modalDetail: ModalDetail
  close: () => void
}> = ({ modalDetail, close }) => {
  return (
    <>
      {modalDetail.messages.length > 0 && (
        <ModalDiv success={modalDetail.success}>
          <MessageDiv>
            {modalDetail.messages.map((message) => (
              <p key={message}>{message}</p>
            ))}
          </MessageDiv>
          <CloseButtonDiv>
            <button onClick={close}>×</button>
          </CloseButtonDiv>
        </ModalDiv>
      )}
    </>
  )
}

const MessageDiv = styled.div`
  width: 90%;
  padding: 24px;
  white-space: nowrap;
`

const CloseButtonDiv = styled.div`
  width: 10%;
  display: flex;
  font-size: 18px;

  align-items: center;
  justify-content: flex-end;
  padding-right: 30px;
`

const ModalDiv = styled.div<{ success: boolean }>`
  display: flex;
  position: fixed;
  bottom: 24px;
  left: 24px;

  font-size: 14px;
  line-height: 20px;

  color: ${({ success }) => (success ? truewhite : errorRed)};
  background-color: ${({ success }) => (success ? accentColor : '#FCE9EA')};

  border-radius: 10px;
  box-shadow: 0px 2px 4px 0px #00000033;
`

const SucceededMessage = styled.div`
  margin: 0 auto 10px;
  max-width: 610px;
  > div {
    display: flex;
    align-items: center;
    padding: 20px 10% 20px 20%;
    border-radius: 12px;
    background-color: ${_profilemenubg};
    color: ${truewhite};
    p {
      flex: 1;
    }
    a {
      font-weight: ${fontWeightBold};
      background-color: ${orange};
      box-shadow: 0px 3px 20px #00000029;
      :hover {
        text-decoration: underline;
      }
    }
  }
`

const ErrorMessages = styled.div`
  margin: 0 auto 10px;
  max-width: 610px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 10% 20px;
  border-radius: 12px;
  background-color: ${errorRed};
  color: ${truewhite};
  font-size: 16px;
  > div {
    margin-top: 20px;
  }
`
